export const no = {
    newUser: {
        continueBtn: "Fortsett",
        h1: "Velkommen til Funki!",
        h2: "For å gjøre opplevelsen din så bra som mulig, begynn med å velge innstillingene dine."
    },    
    admin: {
        customersRouteBtn: "Kunder",
        soundbankSoundsRouteBtn: "Lydbank og sanger",
        usersRouteBtn: "Brukere",

        customersTable: {
            alerts: {
                removeSuccess: "Fjernet",
                removeError: "Feil ved fjerning",
                addSuccess: "La til",
                updateSuccess: "Oppdatert",
                updateError: "Feil ved oppdatering av kunde. Feilmelding"
            },

            mainHeading: "Kunder",
            paymentPlanHeaderName: "Betalingsplan",
            paymentMethodHeaderName: "Betalingsmetode",
            licenseStartHeaderName: "Lisensstart",
            licenseExpireHeaderName: "Lisensutløp",
            instrumentsHeaderName: "Instrumenter",
            soundpackagesHeaderName: "Låtpakker",
            actionsHeaderName: "Handlinger",
            idHeaderName: "ID",
            aliasHeaderName: "Alias",
            contactEmailHeaderName: "Kontakt-e-post",

            gridActionCopyActivationCode: "Kopier aktiveringskode",
            gridActionSave: "Lagre",
            gridActionCancel: "Avbryt",
            gridActionEditSongPackage: "Rediger låtpakke",
            gridActionDelete: "Slett",
            gridActionEdit: "Rediger",
            gridActionEditInstrument: "Rediger instrument"
        },

        customersToolbar: {
            openDialogHeading: "Håndtering av feil",
            openDialogText: "Det ble ikke mulig å opprette ny kunde da et nytt kunde-ID ikke kunne genereres fra databasen.",
            closeDialogBtn: "OK"
        },

        editInstrumentsDialog: {
            heading: "Rediger instrumenter for",
            form: {
                deviceIdLabel: "Enhetens ID",
                instrumentType: "Type",
                submitBtn: "Legg til instrument"
            },
            removeBtn: "Fjern",
            saveBtn: "Lagre",
            cancelBtn: "Avbryt"
        },

        editPackage: {
            heading: "Rediger låtpakke",
            form: {
                submitBtn: "Legg til låtpakke"
            },
            packageNameText: "Pakke navn",
            removeBtn: "Fjern",
            saveBtn: "Lagre",
            cancelBtn: "Avbryt"
        },

        editSongPackageDialog: {
            heading: "Rediger låtpakke for",
            form: {
                submitBtn: "Legg til låtpakke"
            },
            packageNameLabel: "Pakke navn",
            removeBtn: "Fjern",
            saveBtn: "Lagre",
            cancelBtn: "Avbryt"
        },

        songsAndsoundsTable: {
            heading: "Sanger og lyder",

            IdHeader: "Id",
            TitleHeader: "Tittel",
            ImageHeader: "Bilde",
            DescriptionHeader: "Beskrivelse",
            TypeHeader: "Type",
            SongPackageHeader: "Sangpakke",
            CategoryHeader: "Kategori",
            ArtistHeader: "Artist",
            GenreHeader: "Sjanger",
            KeyHeader: "Toneart",
            TempoHeader: "Tempo",
            SectionsHeader: "Seksjoner",
            BackingTrackHeader: "Backingtrack",
            ActionsHeader: "Handlinger",

            gridActionSave: "Lagre",
            gridActionCancel: "Avbryt",
            gridActionDelete: "Slett",
            gridActionEdit: "Rediger",
            gridActionAddImage: "Legg til bilde",
            gridActionSongPackage: "Pakk"
        },

        songsAndSoundsToolbar: {
            failedAction: "Handling mislyktes",
            failedPostCreation: "Mislyktes med å opprette ny låtpost da et nytt låt-ID ikke kunne genereres fra databasen.",

            addSongBtn: "Legg til sang",
            closeDialogBtn: "OK"
        },

        userInfoDialog: {
            heading: "Info - Utvidet brukerstyring",
            infoText: "For øyeblikket kan ikke handlinger som å slette brukerkontoer, endre e-post osv., utføres fra dette admin-grensesnittet. Slike handlinger kan kun utføres i Firebase-konsollen:",
            closeDialogBtn: "OK"
        },

        usersTable: {
            alerts: {
                success: "Oppdaterte brukere",
                error: "Kunne ikke oppdatere brukere. Feilmelding:"
            },
            iDHeader: "Id",
            nameHeader: "Navn",
            emailHeader: "E-post",
            connectedCustomerId: "Tilknyttet kundelisens",
            customerAliasHeader: "Kundealias",
            createdHeader: "Opprettet",
            lastSignedInHeader: "Sist pålogget",
            adminHeader: "Admin",
            actionsHeader: "Handlinger",
            gridActionSave: "Lagre",
            gridActionCancel: "Avbryt",
            gridActionEdit: "Rediger",
            gridActionInfo: "Info",
            usersHeading: "Brukere"
        }    
    },

    components: {
        navbar: {
            logoutBtn: "Logg ut",
            homeRouteBtn: "Hjem",
            libraryRouteBtn: "Bibliotek"
        },
        header: {
            activateAccountRouteBtn: "Aktiver konto",
            loginRouteBtn: "Logg inn",
            headingSettings: "Innstillinger"
        },
        currentlyPlaying: {
            textGenre: "Sjanger",
            textKey: "Tonart",
            textTempo: "Tempo"
        },
        changePassword: {
            form: {
                currentPasswordLabel: "Nåværende passord",
                newPasswordLabel: "Nytt passord",
                submitBtn: "Endre passord",
                validation: {
                    alerts: {
                        success: "Passordet er endret",
                        validationFail: "Det er feil i skjemaet nedenfor",
                        userPasswordError1: "Angitt nåværende passord er feil",
                        userPasswordError2: "Ugyldig passord",
                        weakPassword: "Passordet er for svakt eller vanlig, velg et annet nytt passord",
                        firebaseError: "Feilet ved endring av passord...",
                        generalError: "Feilet ved endring av passord..."
                    }
                }
            }
        },
        card: {
            albumCoverImgAlt: "Plateomslag",
            playingLabel: "Spiller",
            keyText: "Tonart:",
            composer: "Komponist:", 
            backgroundTrackText: "Bakgrunnsspor:",
            backgroundTrackYesText: "Ja"
        }
    },

    assetsComponents: {
        menuWithContent: {
            h3UserGreeting: "Velkommen",
            settingsBtn: "Innstillinger",

            libraryHeading: "Bibliotek",
            evaluationHeading: "Vurdering",

            homeRouteBtn: "Hjem",
            musicRouteBtn: "Musikk",
            soundscapesRouteBtn: "Lydlandskap",
            keysRouteBtn: "Nøkler",
            libraryRouteBtn: "Bibliotek",
            activateAccountRouteBtn: "Aktiver Konto",
            loginRouteBtn: "Logg Inn",

            evaluationRouteBtnPre: "Før",
            evaluationRouteBtnAfter: "Etter",
            evaluationRouteBtnFull: "Full",
        },
            evaluationActiveModal: {
                dialogTitle: "Det er en pågående evaluering",
                dialogContentText: "Hva vil du gjøre?",
                newCheckinBtn: "Start ny innsjekking",
                continueCheckoutBtn: "Fortsett med utsjekking",
            },
            evaluationTypeModal: {
                dialogTitle: "Hvor mange følelser skal kunne velges?",
                dialogContentText: "Ved 3 følelser velger man ved å trykke på et symbol, og ved 5 følelser velger man ved å dra i en glidebryter.",
            },
            evaluationStageModal: {
                dialogTitle: "Hvilken type evaluering vil du gjøre?",
                dialogContentText: "Du kan velge mellom enkel (1 spørsmål) eller utvidet (flere spørsmål)."
            },            
            evaluationBtn: {
                btnA: "Start Evaluering",
                btnB: "Fortsett Evaluering"
            },
    },

    home: {
        masterVolume: {
            paragraphMaster: "Master volum"
        },
        instruments: {
            headingWaiting: "Venter på Funki-instrumentene"
        },
        instrumentInformation: {
            paragraphSound: "Lyd",
            paragraphMusic: "Musikk",
            paragraphSoundscape: "Lydlandskap",
            paragraphKey: "Toneart",
            paragraphChooseSound: "Velg Lyd",
            headingChooseSound: "Velg Lyd"
        },
        touchAlternateMode: {
            easyBtn: "Lett",
            hardBtn: "Vanskelig"
        }
    },

    library: {
        libraryComponent: {
            searchTermMusic: "Musikk",
            searchTermSoundscapes: "Lydlandskap",
            searchTermKeys: "Nøkler",
            musicRouteBtn: "Musikk",
            soundscapesRouteBtn: "Lydlandskap",
            keysRouteBtn: "Nøkkel",
            searchbarPlaceholder: "Søk etter %{displayedSearchTerm}"
        },
        displayedCards: {
            tableCellName: "Navn",
            tableCellProducer: "Produsent",
            tableCellKey: "Nøkkel",
            tableCellScale: "Skala"
        }
    },

    settings: {
        accountRouteBtn: "Konto",
        licenseRouteBtn: "Lisens",
        logoutBtn: "Logg ut",
        aboutRouteBtn: "Om",
        adminRouteBtn: "Admin",

        account: {
            headingEmail: "Koblet E-postadresse",
            headingPassword: "Passord",
            accordionPassword: "Endre Passord",
            headingLicense: "Lisens Knyttet",
            headingNoLicense: "Ingen Lisens Knyttet",
            bodyNoLicense: "Kontoen din er ikke knyttet til en lisens ennå",
            connectLicenseRouteBtn: "Koble en Lisens",
            changeLanguage: "Språk"
        },

        license: {
            headingOwner: "Lisenseier",
            headingPaymentPlan: "Betalingsplan",
            headingConnectedInstruments: "Instrumenter som er koblet",
            bodyConnectedInstruments: "Ingen instrumenter er koblet",
            boxActive: "Aktiv",
            resetWifiPasswordBtn: "Tilbakestill WiFi-passord"
        }
    },

    evaluationTool: {
        evaluationStart: {
            startBtnBefore: "START NY INNSJEKKING",
            startBtnAfter: "START NY UTSJEKKING",
            startBtnFull: "START NY EVALUERING",
            
            imgAltA: "start",
            imgAltB: "evaluering",
        },
        evaluationQuestion: {
            forwardBtn: "FORTSETT",
            questionBeforeAfter:"HVORDAN HAR DU DET?",
            questionsFull:{
                question1:"HVORDAN FØLTE DET SEG Å SPILE I DAG?",
                question2:"HVORDAN HAR DU DET?",
                question3:"VIL DU SPILE IGJEN?",
            },
            answerBeforeAfter: {
                textContent1: "DÅRLIG",
                textContent2: "MIDDELS",
                textContent3: "BRA",
                imgAlt1: "widget-dårlig",
                imgAlt2: "widget-sånn-passe",
                imgAlt3: "widget-bra",

                answersSlider: {
                    textContent1: "FORFERDELIG",
                    textContent2: "DÅRLIG",
                    textContent3: "SÅNN PASSE",
                    textContent4: "BRA",
                    textContent5: "VELDIG BRA",
                    imgAlt1: "widget-forferdelig",
                    imgAlt2: "widget-dårlig",
                    imgAlt3: "widget-sånn-passe",
                    imgAlt4: "widget-bra",
                    imgAlt5: "widget-veldig-bra",
                }                
            },
            answerFull:{
                answer1: {
                    textContent1: "DÅRLIG",
                    textContent2: "SÅNN PASSE",
                    textContent3: "BRA", 
                    imgAlt1: "smiley-dårlig",
                    imgAlt2: "smiley-sånn-passe",
                    imgAlt3: "smiley-veldig-bra"
                },
                answer2: {
                    textContent1: "TRØTT",
                    textContent2: "SÅNN PASSE",
                    textContent3: "PIGG",
                    imgAlt1: "smiley-trøtt",
                    imgAlt2: "smiley-sånn-passe",
                    imgAlt3: "smiley-pigg"
                },
                answer3: {
                    textContent1: "NEI",
                    textContent2: "KANSKJE",
                    textContent3: "JA", 
                    imgAlt1: "smiley-dårlig",
                    imgAlt2: "smiley-sånn-passe",
                    imgAlt3: "smiley-veldig-bra"
                }
            }
        },
        evaluationEnd: {
            h1: "TAKK FOR SVARET DITT",
            imgAltA: "klar",
            btnTextFull: "NÅ ER DET SLUTT, TAKK FOR I DAG",
            startBtn: "START",
            backBtn: "ENDRE SVAR",
        },
        endCurrentModal: {
            yesBtn: "JA, AVSLUTT",
            noBtn: "NEI, FORTSETT",
            h1: "VIL DU AVBRYTE INNSJEKKINGEN",
            confirmationTextContent: "INNSJEKKING AVBRUTT",
        },
        endModal: {
            yesBtn: "JA",
            noBtn: "NEI",
            h1: "VIL DU AVSLUTTE OG LAGRE ( %{answerCount} ) SVAR?",
            confirmationTextContent: "TAKK! ( %{answerCount} ) SVAR ER LAGRET"
        },
        backForwardButtonBox: {
            endBtn: "AVSLUTT",
        },
    },

    logIn: {
        form: {
            emailLabel: "E-postadresse",
            passwordLabel: "Passord",
            loginBtn: "Logg inn",
            validation: {
                nonValidEmail: "Ugyldig e-postadresse",
                promptEmail: "Fyll inn din e-postadresse",
                promptPassword: "Fyll inn ditt passord",
                alerts: {
                    general: "Det er feil i skjemaet nedenfor",
                    emailPassword: "Ugyldig e-postadresse eller passord",
                    fail: "Innloggingen mislyktes..."
                }
            }
        },
        account: {
            forgotPasswordBtn: "Glemt passord?",
            registerAccountBtn: "Opprett ny konto"
        }
    },

    requestPasswordReset: {
        heading: "Har du glemt passordet ditt?",
        paragraph: "Fyll inn e-postadressen din, så sender vi deg en lenke slik at du kan velge et nytt passord.",
        backToLoginBtn: "Tilbake til Innlogging",
        form: {
            emailLabel: "E-postadresse",
            continueBtn: "Fortsett",
            validation: {
                nonValidEmail: "Ugyldig e-postadresse",
                promptEmail: "Vennligst fyll inn e-postadressen din",
                continueBtn: "Fortsett",
                alerts: {
                    success: "Vi har sendt en lenke til %{email}. Klikk på lenken og følg instruksjonene i det nye vinduet som åpnes. Hvis du ikke ser e-posten, sjekk søppelpostmappen.",
                    error: "Det er feil i skjemaet nedenfor"
                }
            }
        }
    },

    resetPassword: {
        heading: "Velg ditt nye passord",
        backToLoginBtn: "Tilbake til Logg inn",
        form: {
            newPasswordLabel: "Nytt Passord",
            savePasswordBtn: "Lagre Passord",
            validation: {
                nonValidPassword: "Må være minst 8 tegn",
                alerts: {
                    expiredLink: `Lenken for å tilbakestille passordet har utløpt, vennligst send en ny forespørsel om å tilbakestille passordet`,
                    brokenLink: `Lenken for å tilbakestille passordet er enten ødelagt eller har allerede blitt brukt, vennligst send en ny forespørsel om å tilbakestille passordet`,
                    success: "Det nye passordet har blitt lagret",
                    error: "Feil ved å sette nytt passord",
                    general: "Det er feil i skjemaet nedenfor"
                }
            }
        }
    },

    signUp: {
        backToLoginBtn: "Tilbake til Logg inn",
        form: {
            nameLabel: "Navn (valgfritt)",
            emailLabel: "E-postadresse",
            passwordLabel: "Passord",
            createAccountBtn: "Opprett konto",
            validation: {
                nonValidName: "Maks 50 tegn langt",
                nonValidEmail: "Ugyldig e-postadresse",
                nonValidPassword: "Må være minst 8 tegn",
                required: "Obligatorisk",

                alerts: {
                    general: "Det er feil i skjemaet nedenfor",
                    emailDuplicate: "Det finnes allerede en konto knyttet til e-postadressen",
                    passwordWeak: "Passordet er for svakt eller vanlig, velg et annet passord",
                    success: "Bruker opprettet",
                    fail: "Feil ved oppretting av bruker..."
                }
            }
        }
    },

    activateAccount: {
        heading: "Kontoen din er ikke koblet til noen lisens ennå",
        paragraph: "For å aktivere kontoen din og koble til en lisens, skriv inn aktiveringskoden for lisensen nedenfor.",
        paragraphLoading: "Laster",
        noActivationCodeBtn: "Har du ingen aktiveringskode?",
        backToLoginBtn: "Tilbake til pålogging",
        form: {
            activateBtn: "Aktiver",
            activationCodeLabel: "Aktiveringskode",
            validation: {
                alerts: {
                    success: "Aktiveringen var vellykket",
                    error: "Noe gikk galt under aktiveringen, vennligst prøv igjen eller kontakt oss på Funki hvis problemet vedvarer",
                    nonValidCode: "Den oppgitte aktiveringskoden er ugyldig"
                }
            }
        }
    },

    loading: {
        paragraph: "Laster..."
    }
}
